<template>
    <div class="surface-section">
        <ul class="list-none p-0 m-0 surface-container">
            <li class="py-3 px-2 border-top-1 surface-border">
                <div class="text-500 w-6 md:w-2 font-medium">Id</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ formula.id }}</div>
            </li>
            <li class="py-3 px-2 border-top-1 surface-border">
                <div class="text-500 w-6 md:w-2 font-medium">Code</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ formula.code }}</div>
            </li>
            <li class="py-3 px-2 border-top-1 surface-border">
                <div class="text-500 w-6 md:w-2 font-medium">Description</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ formula.description }}</div>
            </li>
            <li class="py-3 px-2 border-top-1 surface-border">
                <div class="text-500 w-6 md:w-2 font-medium">Type</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ getFormulaType(formula.type) }}</div>
            </li>
            <li class="py-3 px-2 border-top-1 surface-border">
                <div class="text-500 w-6 md:w-2 font-medium">Formula</div>
                <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                    <span class="mr-1" v-for="item in formula.formula" :key="item">
                        {{ item.code ?? item.value }}
                    </span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { getFormulaType } from '@/helpers/enum-helpers';
import useFormulaComposable from '@/composables/FormulaComposable';
const { formula } = useFormulaComposable();
</script>

<style scoped>
.surface-section > .surface-container {
    overflow-y: auto;
}
li {
    display: flex;
    flex-direction: row;
}
li > div {
    display: flex;
    justify-content: left;
    align-items: center;
}
li > div:nth-child(odd) {
    width: 30% !important;
}
li > div:nth-child(even) {
    width: 70% !important;
}
</style>
